import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import H1 from "../../../components/typography/H1";
import { useInView } from "react-intersection-observer";
import { RiShare2Line } from "react-icons/ri";
import { RxCopy } from "react-icons/rx";
import { PiHeartFill } from "react-icons/pi";
import ProductCard from "../../../components/cards/ProductCard";

const Wrapper = styled.div``;

const Container = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
`;

const TabsWrapper = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 8px;
  flex-wrap: wrap;
  cursor: pointer;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

const Column = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

const Utilities = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Total = styled.span`
  font-size: ${fontSize.xs};
  color: ${colors.primaryGray};
`;

const ShareWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: fit-content;
  flex-direction: column;
  align-items: flex-end;
`;

const Share = styled.div`
  display: flex;
  gap: 4px;
  cursor: pointer;

  span {
    position: relative;
    background: none;
    border: none;
    padding: 0;
    letter-spacing: 0.08rem;
    font-size: ${fontSize.xs};

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -4px;
      width: 100%;
      height: 1px;
      background-color: ${colors.black};

      transform: translateX(-50%) scaleX(0);
      transform-origin: center;
      transition: transform 0.3s ease;
    }

    &:hover::after {
      transform: translateX(-50%) scaleX(1);
    }
  }
`;

const ShareInputWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  transform-origin: center;
  transition: transform 0.5s ease, opacity 0.5s ease;
  transform: ${({ show }) => (show ? "scaleY(1)" : "scaleY(0)")};
  opacity: ${({ show }) => (show ? 1 : 0)};
`;

const ShareInput = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-top: 8px;

  span {
    font-size: ${fontSize.xxs};
    border-bottom: 1px solid ${colors.black};
  }

  svg {
    cursor: pointer;
  }
`;
const WishListGrid = styled.div`
  display: grid;
  gap: 64px 24px;
  margin: 24px 0;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
`;

const Description = styled.p`
  max-width: 300px;
  text-align: center;
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.black};
  font-size: ${fontSize.xs};
`;

function WishlistSection() {
  const { ref, inView } = useInView({ triggerOnce: true });
  const [showShareInput, setShowShareInput] = useState(false);
  const URL =
    "https://www.peak-pashmina.com/favorites/e001e7c4efa7db44231ccd9964";

  const toggleShareInput = () => {
    setShowShareInput((prev) => !prev);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(URL).then(() => {
      alert("Copied to clipboard!");
    });
  };

  return (
    <Wrapper ref={ref} inView={inView}>
      <Container>
        <Column>
          <Utilities>
            <Total>5 item(s)</Total>
            <ShareWrapper>
              <Share onClick={toggleShareInput}>
                <RiShare2Line />
                <span>Share my wishlist</span>
              </Share>
            </ShareWrapper>
          </Utilities>

          <ShareInputWrapper show={showShareInput}>
            <ShareInput>
              <span>{URL}</span>
              <RxCopy onClick={copyToClipboard} style={{ cursor: "pointer" }} />
            </ShareInput>
          </ShareInputWrapper>
        </Column>
{/* 
        <WishListGrid>
          {Array.from({ length: 8 }).map((_, i) => (
            <ProductCard key={i} />
          ))}
        </WishListGrid> */}

        <Header>
          <PiHeartFill size={40} />
          <Description>
            The wishlist is empty - start hearting favorites while you shop
          </Description>
        </Header>
      </Container>
    </Wrapper>
  );
}

export default WishlistSection;
